import { InstrumentationProgress, Line } from '../types/interfaces';

export const AVALES_INSTRUMENTATION_INFO_BANNER =
  'Las líneas se activan para su gestión en Avales.';

export const ONECLICK_LINE_ACTIVATION_FALLBACK =
  'No se pudo activar la línea en OneClick. Usá Reintentar.';

export const ONECLICK_LINES_SECTION_WARNING =
  'Una o más líneas no se activaron en OneClick. Revisá el detalle de cada línea y usá Reintentar.';

export function isAvalesInstrumentationMode(isGuaranteesEnabled: boolean): boolean {
  return isGuaranteesEnabled === true;
}

/** Avales ON (o OneClick off en API cuando guarantees off): ocultar flujo OneClick legacy. */
export function shouldSkipOneClickInstrumentationUi(
  isGuaranteesEnabled: boolean,
  oneClickEnabledFromApi?: boolean
): boolean {
  if (isAvalesInstrumentationMode(isGuaranteesEnabled)) {
    return true;
  }
  return oneClickEnabledFromApi === false;
}

export function shouldShowLineWarning(
  skipOneClickUi: boolean,
  hasActivationAttempt: boolean,
  instrumentationId: string | null | undefined
): boolean {
  if (skipOneClickUi) {
    return false;
  }
  return hasActivationAttempt && (instrumentationId === null || instrumentationId === undefined);
}

/** Alias semántico del plan — misma regla que shouldShowLineWarning. */
export function isLineInWarningState(
  skipOneClickUi: boolean,
  hasActivationAttempt: boolean,
  instrumentationId: string | null | undefined
): boolean {
  return shouldShowLineWarning(skipOneClickUi, hasActivationAttempt, instrumentationId);
}

export function isLineSuccessInOneClickMode(
  skipOneClickUi: boolean,
  instrumentationId: string | null | undefined
): boolean {
  if (skipOneClickUi) {
    return false;
  }
  return instrumentationId !== null && instrumentationId !== undefined;
}

export function resolveLineProgress(
  line: Pick<Line, 'id' | 'instrumentation_progress'>,
  statusMap: Map<number, InstrumentationProgress>
): InstrumentationProgress | undefined {
  return statusMap.get(line.id) ?? line.instrumentation_progress;
}

export function getInstrumentationActivationErrorMessage(
  errorCode?: string,
  defaultMessage?: string
): string {
  switch (errorCode) {
    case 'LIMIT_DUPLICATE':
      return 'El límite por línea ya existe. No se puede duplicar.';
    case 'LIMIT_NOT_FOUND':
      return 'No existe un límite por línea general instrumentado. Se requiere crear el límite antes de continuar.';
    case 'ONECLICK_500':
      return 'Error temporal al comunicarse con OneClick. Por favor, intente nuevamente.';
    case 'ONECLICK_NOT_FOUND':
      return 'No se encontró el recurso solicitado en OneClick.';
    case 'ONECLICK_EMPTY_RESPONSE':
      return 'OneClick retornó una respuesta vacía. Por favor, intente nuevamente.';
    default:
      return defaultMessage || 'Ocurrió un error al activar las líneas de producto';
  }
}

export function getLineWarningMessage(progress?: InstrumentationProgress): string {
  if (progress?.error?.message) {
    return progress.error.message;
  }
  if (progress?.error?.code) {
    return getInstrumentationActivationErrorMessage(progress.error.code);
  }
  return ONECLICK_LINE_ACTIVATION_FALLBACK;
}
